import { SKILL_LIST, type SkillKey } from "@mathtrain/engine";
import { useSearchParams } from "react-router-dom";
import { Board } from "../components/Board";
import { api } from "../lib/api";
import { useLoad } from "../lib/hooks";
import type { BoardRow } from "../lib/types";

const BOARDS = [
  ["week", "Week", "Points this week. Resets Monday."],
  ["month", "Month", "Points this month."],
  ["all", "All time", "Points since the beginning."],
  ["daily", "Daily", "Today's challenge. Same problems for everyone."],
  ["streak", "Streak", "Consecutive days with at least one problem."],
  ["skill", "By skill", "Current level in one skill."],
] as const;

export function Ranks() {
  const [q, setQ] = useSearchParams();
  const board = q.get("board") ?? "week";
  const skill = (q.get("skill") ?? "mul") as SkillKey;
  const { data, error } = useLoad(() => api<{ rows: BoardRow[] }>(`/leaderboard?board=${board}${board === "skill" ? `&skill=${skill}` : ""}`), [board, skill]);
  const meta = BOARDS.find((b) => b[0] === board) ?? BOARDS[0];
  const fmt = board === "skill" ? (v: number) => v.toFixed(2) : board === "streak" ? (v: number) => `${v}d` : (v: number) => String(v);
  return <main className="page">
    <h1>Ranks</h1>
    <div className="chips" role="group" aria-label="Leaderboard">
      {BOARDS.map(([k, label]) => <button key={k} aria-pressed={board === k} onClick={() => setQ(k === "skill" ? { board: k, skill } : { board: k }, { replace: true })}>{label}</button>)}
    </div>
    {board === "skill" && <div className="chips" role="group" aria-label="Skill" style={{ marginTop: 8 }}>
      {SKILL_LIST.map((s) => <button key={s.key} aria-pressed={skill === s.key} onClick={() => setQ({ board, skill: s.key }, { replace: true })}>{s.name}</button>)}
    </div>}
    <p className="small mute">{meta[2]}</p>
    <div className="card">
      {error ? <div className="error">{error}</div> : !data ? <div className="empty">Loading…</div>
        : <Board rows={data.rows} format={fmt} empty={board === "daily" ? "No one has played today's challenge yet." : "No one yet."} />}
    </div>
  </main>;
}
